import { useContext } from "react";
import { AppContext } from "../App";
import { FiActivity, FiUsers, FiHeart, FiShield, FiTarget } from "react-icons/fi";

export default function ClinicalServices() {
  const appContext = useContext(AppContext);

  const services = [
    {
      icon: <FiActivity />,
      title: "Outpatient & General Consultation (OPD)",
      desc: "Comprehensive same-day medical consultations for acute illnesses, chronic disease follow-up, minor complaints, and general health concerns."
    },
    {
      icon: <FiUsers />,
      title: "Family Care Model",
      desc: "A progressive care model that builds a continuous therapeutic relationship between the clinician and the family unit across generations."
    },
    {
      icon: <FiHeart />,
      title: "Non-Communicable Disease Clinic",
      desc: "Dedicated chronic disease management space for hypertension, diabetes, dyslipidemia, asthma, cardiovascular disease, and long-term conditions."
    },
    {
      icon: <FiShield />,
      title: "Minor Surgical Procedures Unit",
      desc: "Interventions not requiring general anesthesia: complex wound debridement, suturing, abscess incision/packing, cyst/lipoma excision, and circumcisions."
    },
    {
      icon: <FiTarget />,
      title: "Mental Health & Counseling",
      desc: "Structured psychological and counseling frameworks for common conditions including depression, anxiety, workplace stress, trauma, grief, and addiction."
    }
  ];

  return (
    <div className="pillar-container">
      <div className="pillar-header">
        <h2 className="pillar-title">Clinical Services</h2>
        <p className="pillar-subtitle">Primary and therapeutic healthcare pathways running on unified medical protocols.</p>
      </div>

      <div className="pillar-grid">
        {services.map((item, idx) => (
          <div 
            key={idx} 
            className="pillar-card"
            onClick={() => appContext.navTo({ item: "contact_us" })}
          >
            <div className="pillar-icon">{item.icon}</div>
            <h3 className="pillar-card-title">{item.title}</h3>
            <p className="pillar-card-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}